import type { CostEstimate } from '@cartwheel/api/v1'
import { PerSessionSummary } from './per-session-summary'

interface MedicaidEstimateDisplayProps {
  estimate: CostEstimate
}

export function MedicaidEstimateDisplay({ estimate }: MedicaidEstimateDisplayProps) {
  const { editable, post_deductible_cost: postDeductible } = estimate

  return (
    <>
      <div className="my-4">
        <div className="flex justify-between py-2 px-4 border-b border-gray-stroke font-medium">
          <span>Cost</span>
          <span>{postDeductible.amount}</span>
        </div>

        {editable.session_limit !== null && (
          <div className="flex justify-between py-2 px-4 border-b border-gray-stroke font-medium">
            <span>Session Limits</span>
            <span>{editable.session_limit}</span>
          </div>
        )}
      </div>

      <div className="flex justify-center">
        <PerSessionSummary
          label="Medicaid"
          labelColor="lavender-50"
          perSessionAmount={postDeductible.amount}
        />
      </div>
    </>
  )
}
